/**
 * Header account dropdown.
 */
(() => {
  let accountMenuController = null;

  function initHeaderAccountMenus() {
    accountMenuController?.abort();
    accountMenuController = new AbortController();
    const { signal } = accountMenuController;

    const buttons = document.querySelectorAll('.header__icon--account-button');
    if (!buttons.length) return;

    const closeAll = () => {
      buttons.forEach((btn) => {
        const id = btn.getAttribute('aria-controls');
        const menu = id ? document.getElementById(id) : null;
        btn.setAttribute('aria-expanded', 'false');
        if (menu) menu.setAttribute('hidden', '');
      });
    };

    const openStates = new WeakMap();

    buttons.forEach((button) => {
      const root = button.closest('.header__icon--account');
      const menuId = button.getAttribute('aria-controls');
      const menu = menuId ? document.getElementById(menuId) : null;
      if (!root || !menu) return;

      let shouldFocusCloseOnOpen = false;

      const setOpen = (open) => {
        if (open) closeAll();
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        openStates.set(button, open);
        if (open) menu.removeAttribute('hidden');
        else menu.setAttribute('hidden', '');

        if (open) {
          if (shouldFocusCloseOnOpen) {
            menu.querySelector('.e-block-box__close')?.focus({ preventScroll: true });
          }
          shouldFocusCloseOnOpen = false;
        }
      };

      const isOpen = () => openStates.get(button) === true;

      button.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          setOpen(!isOpen());
        },
        { signal }
      );

      button.addEventListener(
        'keydown',
        (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            shouldFocusCloseOnOpen = true;
          }
        },
        { signal }
      );

      const closeButton = menu.querySelector('.e-block-box__close');
      if (closeButton) {
        closeButton.addEventListener(
          'click',
          (e) => {
            e.preventDefault();
            setOpen(false);
            button.focus({ preventScroll: true });
          },
          { signal }
        );

        closeButton.addEventListener(
          'keydown',
          (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              setOpen(false);
              button.focus({ preventScroll: true });
            }
          },
          { signal }
        );
      }

      document.addEventListener(
        'focusin',
        (e) => {
          if (!isOpen()) return;
          if (e.target?.closest?.('a.skip-to-content-link')) {
            menu.querySelector('.e-block-box__close')?.focus({ preventScroll: true });
          }
        },
        { signal }
      );

      document.addEventListener(
        'click',
        (e) => {
          if (!isOpen()) return;
          const path = typeof e.composedPath === 'function' ? e.composedPath() : [];
          if (path.includes(root) || path.includes(menu) || root.contains(e.target)) return;
          setOpen(false);
          button.focus({ preventScroll: true });
        },
        { capture: true, signal }
      );
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderAccountMenus);
  } else {
    initHeaderAccountMenus();
  }
})();
